import { render, staticRenderFns } from "./viewDetails.vue?vue&type=template&id=50c4f6a9&"
import script from "./viewDetails.vue?vue&type=script&lang=js&"
export * from "./viewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports